<template>
  <transition name="fade" appear>
    <div class="home-page-view content-wrapper" id="home-page-view" ref="root">
      <!-- <SurveyTrigger class="survey-trigger" /> -->
      <MainMenuWithPreferences pageTitle="Destinations" class="menu">
        <template slot="preferences-menu">
          <MenuTripPreferences />
        </template>
      </MainMenuWithPreferences>

      <div class="mobile-wrapper">
        <div class="mobile-overlay">
          <div class="img"></div>
          <div class="text-primary"><b>Access site from your desktop browser</b></div>
          <div class="text-secondary">
            Mobile devices are currently not supported. Plan your next trip from your web browser on your computer or
            laptop.
          </div>
        </div>

        <HeaderSection class="header-section" whereToGoText="" planTripTextSubText="">
          <!-- 
          <template v-slot:powered>
            <PoweredByMobi class="powered-by-mobi-position" v-if="showPoweredByMobi" />
          </template>
          -->

          <template v-slot:filter-inputs>
            <!-- 
            <BoxShadow class="welcome-box">
              <div class="text-wrapper">
                <p>
                  Plan your dream vacation to Singapore with Mobi’s AI powered Trip Planner, in partnership with Singapore Tourism Board. This website is not owned or affiliated in any way with Singapore Tourism Board.
                </p>
              </div>
            </BoxShadow>
            -->
            <BoxShadow>
              <div class="welcome-box text-wrapper margin-bottom-20">
                <h1>Singapore Trip Planner</h1>
                <span>(Beta)</span>
              </div>
              <div class="text-wrapper">
                <SectionHeader
                  :number="1"
                  text="To get started, describe your interests, and we will build preferences to help you plan your trip."
                  class="margin-top-20 margin-bottom-20"
                />
              </div>
              <div v-if="chatHistory.length > 0" class="chat-history-box">
                <ChatHistoryItem v-for="(message, idx) in chatHistory" :key="`message-${idx}`" :message="message" />
              </div>

              <div class="box-shadow__inner">
                <ChatTextInput
                  :allFilters="availableCommonInterests"
                  :pillsValue="pillsValue1"
                  @clearPill="onSuggestionSelected('')"
                  @update="onChatFiltersUpdate"
                  @update-dates="onDatesUpdate"
                  @update-origin="onOriginChange"
                  @update-destination="onDestinationChange"
                  @update-travelers-and-budget="onChatTravelersAndBudgetUpdate"
                />

                <PillsList :pills="suggestionsPills.pills" @pill-selected="onSuggestionSelected" />
              </div>
            </BoxShadow>

            <BoxShadow class="box-shadow--date" v-if="chatHistory.length && selectedFilters.length">
              <PreferencesBox
                :filterTags="selectedFilters"
                @preferences-click="onCommonFilterClick(interestsFilterConfig)"
                @toggle-tag="updateTripFilters"
              />

              <TripInputs
                id="tour-filters"
                :isPreferencesFilledPopoverDisplayed="isPopoverShow"
                :timeframe="timeFrameFilter.value"
                :travelers="travelersFilter.value"
                :startDate="startDate"
                :endDate="endDate"
                :selectedTags="selectedFilters"
                :isLoading="isLoading"
                @origin-selected="onOriginChange"
                @timeframe-click="onCommonFilterClick(timeFrameFilter)"
                @travelers-click="onCommonFilterClick(travelersFilter)"
                @dates-selected="onDatesUpdate"
                @build-trip="onCreateTripClick"
              />
            </BoxShadow>
          </template>
        </HeaderSection>

        <PoweredByMobiFooter v-if="isFooterAvailable" />
      </div>
    </div>
  </transition>
</template>

<script>
import Vue from 'vue';
// @ts-ignore
import MdModalDialog from 'vue-material-modal-dialog';
import 'vue-material-modal-dialog/dist/components.css';
// @ts-ignore
import {MdDialog} from 'vue-material/dist/components';
// import PoweredByMobi from '@common/powered-by-mobi.vue';
import PoweredByMobiFooter from '@common/powered-by-mobi-footer.vue';
import TripInputs from '@components/common-components/trip-inputs/trip-inputs.vue';
import ChatTextInput from './chat-input/chat-input.vue';
import PillsList from '@common/pills/pills-list.vue';
import suggestionsPills from './suggestion-pills.json';
import MainMenuWithPreferences from '@components/main-menu/main-menu-with-preferences.vue';
import MenuTripPreferences from '@components/main-menu/menu-trip-preferences.vue';
import HeaderSection from '@components/old-home-page/header-section/header-section.vue';
import PreferencesBox from './preferences-box/preferences-box.vue';
import VueCompositionAPI, {ref, computed, onMounted} from '@vue/composition-api';
import {useContent} from '@components/composable/use-content';
import {UserActivityCategoryEnum} from '@mobi-components/global-solution';
import {getModalFilterConfig} from '@components/old-home-page/modal-filter.config';
import {ProblmSubmissionRoute} from '@/store/state/global.types';
import {RouterAliases} from '@/router/routerAliases';
import {useSolutionFilters} from '@components/solution-views/summary-filters';
import {useRouter} from '@/router';
import {FilterKind} from '@common/filter/filter-kind';
import {EMPTY_RECOMMENDATIONS} from '@components/old-home-page/destination-details/dest-details-helper';
import {allovedInterestDomains, getFlightsTags} from '@components/old-home-page/home-helpers';
import {TagCategory} from '@common/filter/interest-filter/interest-filter.vue';
import ChatHistoryItem from '@common/chat/chat-history-item.vue';
import SectionHeader from './section-header/section-header.vue';
import BoxShadow from '@common/blocks/box-shadow.vue';
import DisclaimerModal from '@common/modal/disclaimer-modal.vue';
// import SurveyTrigger from '@common/survey/suvey-trigger.vue';

import {
  loadAvailableDomains,
  getDestination,
  updateDestination,
  getAllSolutionFilters,
  toggleSolutionTags,
  saveDestination,
  loadTripOptions,
  loadNearbyOptions,
  getFirstDestination,
  getNearbyLocations,
  getDestinationOptions,
  updateSolutionDates,
  updateSolutionTravelers,
  updateOrigin,
  dropTripOptions,
  setMissingFilters,
  getStartEndDates,
  getAllSelectedFilters,
} from '@/store/state/helpers';
import {store} from '@/store';
import {ChatHistoryModule} from '@/store/modules';
import {useQueryParams} from '@/router/router';

Vue.use(VueCompositionAPI);
Vue.use(MdDialog);
Vue.use(MdModalDialog);

const SINGAPORE_POI = {
  name: 'Singapore',
  display_name: 'Singapore',
  category: 'CITY',
  id: 'ffcb602a-96e3-331f-953f-fb8876d86d87',
  lat: 1.29378,
  lng: 103.853256,
  type: 'city',
};

function useHome(root) {
  const queryParams = useQueryParams();
  const selectedTrip = ref(null);
  const tripsForSelectedCard = ref({recommendations: EMPTY_RECOMMENDATIONS});
  const isTripLoading = ref(false);
  const isLoading = ref(false);
  const isCardSelected = ref(false);
  const isPopoverShow = ref(false);
  const groupHash = ref({});
  const chatHistory = computed(() => ChatHistoryModule.getMessages());

  const solutionFilters = computed(() => {
    const tags = getAllSolutionFilters();

    // update groupHash with selected tags
    groupHash.value = tags
      .filter((x) => x.value)
      .reduce((r, x) => {
        r[x.name.toLowerCase()] = true;
        return r;
      }, {});

    return tags;
  });

  const startDate = computed(() => {
    return getStartEndDates().start;
  });

  const endDate = computed(() => {
    return getStartEndDates().end;
  });

  const destOption = computed(() => {
    return getDestination();
  });

  const destinationContext = computed(() => {
    return getFirstDestination();
  });

  const availableCommonFlightFilters = computed(() => getFlightsTags(solutionFilters.value));
  const selectedFilters = computed(() => getAllSelectedFilters());

  const availableCommonInterests = computed(() => {
    return solutionFilters.value.filter((x) => allovedInterestDomains.includes(x.domain));
  });

  // prettier-ignore
  const {travelersFilter, timeFrameFilter, solutionTravlersFilter, solutionTimeFrameFilterValue} =
    useSolutionFilters(root);

  const travelersConfig = {
    get filterValue() {
      return solutionTravlersFilter.value;
    },
    onSelectionChange: async (value) => {
      updateSolutionTravelers(value);

      updateDestinationOptions();

      updateSelectedTrip(selectedTrip.value);
    },
  };

  const timeFrameConfig = {
    get filterValue() {
      return solutionTimeFrameFilterValue.value;
    },

    get activeSlot() {
      return true;
    },

    onSelectionChange: async (value) => {
      // update dates in solution
      updateSolutionDates(value.from, value.to);

      // TODO: rename to meaningful name
      await updateThemeOptions();

      // TODO: rename to meaningful name
      updateSelectedTrip(selectedTrip.value);
    },
  };

  const interestsFilterConfig = {
    label: 'Filter By',
    value: 'Your Interests',
    type: FilterKind.INTERESTS,
    isActive: availableCommonInterests.value.some((x) => x.value),
    counter: availableCommonInterests.value.filter((x) => x.value && x.domain !== UserActivityCategoryEnum.GEOLOCATION)
      .length,
  };

  const updateTripFilters = (filters) => {
    updateCommonStoreTags([...availableCommonInterests.value, ...availableCommonFlightFilters.value], filters);
  };

  const nearbyLocations = computed(() => {
    return getNearbyLocations();
  });

  const isCountrySelected = computed(() => {
    return destOption.value?.type.toLowerCase() === 'country';
  });

  const isAirportSelected = computed(() => {
    return destOption.value?.type.toLowerCase() === 'airport';
  });

  const updateSelectedTrip = (poi) => {
    selectedTrip.value = poi;
  };

  const onShowDisclaimer = () => {
    const app = document.querySelector('#app');
    app.inert = true;
    root.$modal
      .show(DisclaimerModal, {})
      .catch(() => null)
      .finally(() => {
        app.inert = false;
      });
  };

  ///////////////////////////////////////////////////////////////////////////////////////////////
  // Methods
  onMounted(() => {
    if (queryParams.value.source) {
      onShowDisclaimer();
    }

    if (isCardSelected.value) return;
    isCardSelected.value === true;

    // TODO: #SNG Singapore only hack
    updateSelectedTrip(SINGAPORE_POI);
  });

  const onDestinationChange = async (value) => {
    await updateDestination(value);
    updateDestinationOptions();
  };

  const onOriginChange = async (value) => {
    await updateOrigin(value);
    updateDestinationOptions();
  };

  const updateCommonStoreTags = async (filters, updatedTags) => {
    const off = (filters.value || filters).filter((x) => x.value).map((x) => ({...x, value: false}));

    await toggleSolutionTags([...off, ...updatedTags]);
  };

  const isPopOverShowActivation = () => {
    isPopoverShow.value = true;
    setTimeout(() => {
      isPopoverShow.value = false;
    }, 5000);
  };

  const onChatFiltersUpdate = (selectedFilters) => {
    // merge new filters with already selected
    const alreadySelectedFilters = getAllSelectedFilters();
    const mergedSelectedFilters = alreadySelectedFilters.concat(selectedFilters);

    toggleSolutionTags(mergedSelectedFilters);

    isPopOverShowActivation();
  };

  const onDatesUpdate = ({startDate, endDate}) => {
    timeFrameConfig.onSelectionChange({from: startDate.valueOf(), to: endDate.valueOf()});
  };

  const onChatTravelersAndBudgetUpdate = ({travelersInformation, budget}) => {
    setMissingFilters([], travelersInformation, budget);
  };

  // TODO: refactor this in common piece of code for all pages
  const onCommonFilterClick = (filter, category) => {
    const modalForFilter = getModalFilterConfig(filter.type);
    if (modalForFilter) {
      const configs = {
        interestsConfig: {
          get availableTags() {
            return [...availableCommonInterests.value, ...availableCommonFlightFilters.value];
          },
          // if category is not set, we just set availableCategories to, and show first default category
          availableCategories: {
            [category || TagCategory.ACCOMMODATION]: true,
          },
          onSelectionChange: (tags) => updateCommonStoreTags(availableCommonInterests, tags),
        },
        travelersConfig,
        timeframeConfig: timeFrameConfig,
      };

      const config = configs[modalForFilter.key];
      root.$modal
        .show(modalForFilter.modal, config)
        .then((updatedFilters) => {
          updatedFilters && config.onSelectionChange(updatedFilters);
        })
        .catch(() => {
          config.onSelectionChange([]);
        });
    }
  };

  const onCreateTripClick = async (tripInfoArr) => {
    if (!tripInfoArr || tripInfoArr.empty) {
      console.warn('onCreateTripClick(): no trip info provided');
      return;
    }

    // get first destination
    const tripInfo = tripInfoArr[0];

    // TODO: do we need this here???
    // update solution filters
    await updateDestination(tripInfo.destination);
    await updateOrigin(tripInfo.origin);

    // load trips solution of context
    await loadTripsForDestinationContext();

    // get context & trips
    const firstDestinationContext = getFirstDestination();
    const destinationContextId = firstDestinationContext.id.replace(/\+.*$/g, '');
    const trips = getDestinationOptions()[destinationContextId];

    // redirect to summary page with empty trip
    const firstTrip = trips && trips.length ? trips.find((x) => !x.theme) : null;
    if (firstTrip) {
      const router = useRouter();
      router.push({
        name: RouterAliases.EXPERIENCE_EXPLORE_VIEW,
        params: {tripId: firstTrip.trip_id, contextName: firstTrip.context.name, domain: 'EXPERIENCE'},
      });
    }
  };

  //TODO: move to some helper
  const loadTripsForDestinationContext = async () => {
    isLoading.value = true;

    await loadNearbyOptions();
    if (destinationContext.value && !isCountrySelected.value && !isAirportSelected.value) {
      /* const {trips: tripsWithPois, explanations} = */ await loadTripOptions(
        ProblmSubmissionRoute.DESTINATION,
        {
          id: destinationContext.value.id,
          name: destinationContext.value.contextName,
          lat: destinationContext.value.location.lat,
          lng: destinationContext.value.location.lng,
          time_zone: destinationContext.value.location.time_zone,
          organically_explored: destinationContext.value.organically_explored,
          allowed_modes: [],
        },
        false,
      );
    } else {
      dropTripOptions();
    }

    isLoading.value = false;
  };

  const updateDestinationOptions = async () => {
    isLoading.value = true;

    await loadNearbyOptions();
    if (destinationContext.value && !isCountrySelected.value && !isAirportSelected.value) {
      const {trips: tripsWithPois} = await loadTripOptions(
        ProblmSubmissionRoute.DESTINATION,
        {
          id: destinationContext.value.id,
          name: destinationContext.value.contextName,
          lat: destinationContext.value.location.lat,
          lng: destinationContext.value.location.lng,
          time_zone: destinationContext.value.location.time_zone,
          organically_explored: destinationContext.value.organically_explored,
          allowed_modes: [],
        },
        false,
      );

      tripsForSelectedCard.value = {
        ...tripsForSelectedCard.value,
        [destinationContext.value.id]: tripsWithPois.length ? tripsWithPois : null,
      };

      //      isLoading.value = false;
      //      isFlightsLoading.value = true;
      //      const secondCall = await loadTripOptions(ProblmSubmissionRoute.DESTINATION, {
      //        id: destinationContext.value.id,
      //        name: destinationContext.value.contextName,
      //        lat: destinationContext.value.location.lat,
      //        lng: destinationContext.value.location.lng,
      //        time_zone: destinationContext.value.location.time_zone,
      //        organically_explored: destinationContext.value.organically_explored,
      //        allowed_modes: [],
      //      });

      //      tripsWithPois = secondCall.trips;
      // explanations = secondCall.explanations;

      //      tripsForSelectedCard.value = {
      //        ...tripsForSelectedCard.value,
      //        [destinationContext.value.id]: tripsWithPois.length ? tripsWithPois : null,
      //      };
      //      isFlightsLoading.value = false;
    } else {
      dropTripOptions();
    }

    isLoading.value = false;
  };

  return {
    solutionFilters,
    selectedFilters,
    UserActivityCategoryEnum,
    interestsFilterConfig,
    isLoading,
    isPopoverShow,
    onDestinationChange,
    onOriginChange,
    onCommonFilterClick,
    destinationContext,
    nearbyLocations,
    selectedTrip,
    isTripLoading,
    onCreateTripClick,
    travelersFilter,
    timeFrameFilter,
    updateTripFilters,
    availableCommonInterests,
    onChatFiltersUpdate,
    onChatTravelersAndBudgetUpdate,
    onDatesUpdate,
    startDate,
    endDate,
    chatHistory,
    suggestionsPills,
  };
}

export default {
  name: 'ChatHomePage',
  components: {
    HeaderSection,
    TripInputs,
    MenuTripPreferences,
    ChatTextInput,
    PillsList,
    MainMenuWithPreferences,
    // PoweredByMobi,
    PoweredByMobiFooter,
    PreferencesBox,
    ChatHistoryItem,
    BoxShadow,
    SectionHeader,
    // SurveyTrigger,
  },
  data() {
    return {
      pillsValue1: '',
    };
  },
  methods: {
    onSuggestionSelected(text) {
      this.pillsValue1 = text;
    },
  },

  setup(_, {root}) {
    window.store = store;
    loadAvailableDomains();

    const destination = getDestination();
    if (destination) {
      saveDestination(destination);
    }

    const showPoweredByMobi = process.env.VUE_APP_THEME !== 'MOBI';
    const isHeaderVisible = process.env.VUE_APP_IS_HEADER_VISIBLE || false;
    const isRecentlyViewedSectionShown = process.env.VUE_APP_IS_RECENT_TRIPS_VISIBLE || false;

    return {
      showPoweredByMobi,
      isHeaderVisible,
      googleGeocodeAPIKey: process.env.VUE_APP_GOOGLE_API_GEOCODE_KEY,
      isFooterAvailable: process.env.VUE_APP_IS_FOOTER_VISIBLE || false,
      isRecentlyViewedSectionShown,
      ...useContent(),
      ...useHome(root),
    };
  },
};
</script>

<style scoped lang="scss">
.home-page-view {
  height: 100vh;
  overflow: auto;
  background-color: var(--page-bg, lightgrey);
}

.header-section {
  position: relative;
}

.powered-by-mobi-position {
  position: absolute;
  right: 0;
  top: 50px;
  z-index: 11;
}

.menu {
  position: fixed;
  top: 0;
}

.box-shadow__inner {
  border-radius: 5px;
  border: 1px solid #e1e1e1;
  padding: 20px;
  box-sizing: border-box;
  position: relative;
}

.box-shadow--date {
  margin-top: 20px;
}

.chat-history-box {
  margin-bottom: 30px;
}

.welcome-box {
  margin-bottom: 20px;
  display: flex;
  flex-direction: row;
  align-items: baseline;
}
.welcome-box h1,
.welcome-box span {
  margin: 1em 0;
}

.welcome-box span {
  display: inline-block;
  margin-left: 0.3em;
  color: var(--toneDark-40);
  font-size: var(--tSize-mdlg);
  font-family: var(--font-family-title);
  font-weight: 500;
}

.picture-wrapper {
  margin-right: 40px;
}

.text-wrapper {
  text-align: left;
}

.text-wrapper h3 {
  color: var(--toneDark-100);
  font-size: var(--tSize-lg);
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  margin: 20px 0 0 0;
}

.text-wrapper p {
  color: var(--toneDark-70);
  font-size: var(--tSize-mdlg);
  font-style: normal;
  font-weight: 500;
  line-height: 140%;
  margin: 10px 0 0 0;
  display: inline-block;
  // max-width: 700px;
}
</style>
